import { render, staticRenderFns } from "./Article3.vue?vue&type=template&id=5284b5da&"
import script from "./Article3.vue?vue&type=script&lang=js&"
export * from "./Article3.vue?vue&type=script&lang=js&"
import style0 from "./Article3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports